import { FiInfo, FiMenu } from "react-icons/fi";

const CustomerMenuHeader = ({ restaurantName, profileImage, onInfo, onMenu }) => (
  <header className="sticky top-0 z-40 border-b border-gray-100 bg-white/95 backdrop-blur" dir="rtl">
    <div className="mx-auto flex h-16 max-w-5xl items-center justify-between gap-3 px-4">
      <button type="button" onClick={onMenu} aria-label="باز کردن راهنمای منو" className="flex h-11 w-11 items-center justify-center rounded-xl text-xl text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary/30">
        <FiMenu />
      </button>
      <div className="flex min-w-0 flex-1 items-center justify-center gap-3">
        <img src={profileImage} alt={`نشان ${restaurantName || "رستوران"}`} className="h-10 w-10 shrink-0 rounded-full border border-gray-100 object-cover" />
        <h1 className="truncate text-base font-black text-gray-900 sm:text-lg">{restaurantName || "منوی رستوران"}</h1>
      </div>
      <button type="button" onClick={onInfo} aria-label="اطلاعات رستوران" className="flex h-11 w-11 items-center justify-center rounded-xl text-xl text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary/30">
        <FiInfo />
      </button>
    </div>
  </header>
);

export default CustomerMenuHeader;
